import { Automation } from 'labstep-web/models/automation.model';
import type { Entity } from 'labstep-web/models/entity.model';
import { EntityState } from 'labstep-web/models/entity-state.model';
import { EntityStateWorkflow } from 'labstep-web/models/entity-state-workflow.model';
import { EntityUserRole } from 'labstep-web/models/entity-user-role.model';
import { EntityUserRoleRequirement } from 'labstep-web/models/entity-user-role-requirement.model';
import { ProtocolDevice } from 'labstep-web/models/protocol-device.model';
import { SignatureRequirement } from 'labstep-web/models/signature-requirement.model';
import { getIdAttribute } from 'labstep-web/services/schema/helpers';

const ENTITIES_WITH_GUID_IN_ID = [
  Automation.entityName,
  EntityState.entityName,
  EntityStateWorkflow.entityName,
  EntityUserRole.entityName,
  EntityUserRoleRequirement.entityName,
  ProtocolDevice.entityName,
  SignatureRequirement.entityName,
] as string[];

export const getEntityIdentifier = (
  entityName: string,
  identifier: string | number,
  state: any,
): string | number | undefined => {
  if (ENTITIES_WITH_GUID_IN_ID.includes(entityName)) {
    return identifier;
  }
  const entityPrimaryKey = getIdAttribute(entityName) as
    | 'id'
    | 'guid';

  if (
    typeof identifier === 'string' &&
    identifier.includes('-') &&
    entityPrimaryKey === 'guid'
  ) {
    return identifier;
  }

  if (typeof identifier === 'number' && entityPrimaryKey === 'id') {
    return identifier;
  }

  const entities = state.entities[entityName]?.byId;
  if (!entities) {
    return undefined;
  }

  switch (entityPrimaryKey) {
    case 'id': {
      const entity = Object.values(entities as Entity[]).find(
        (entity: Entity) => entity.guid === identifier,
      );
      return entity?.id;
    }
    case 'guid': {
      const entity = Object.values(entities as Entity[]).find(
        (entity: Entity) => entity.id === identifier,
      );
      return entity?.guid;
    }
    default:
      return undefined;
  }
};
